import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import { store } from './store/rootStore';
import reportWebVitals from './reportWebVitals';
import { Provider } from 'react-redux';
import CustomerTab from 'components/customers/customerTab';

ReactDOM.render(
  // <React.StrictMode>
  //     <CustomerTab />
  //   </React.StrictMode>,
  <Provider store={store}>
    <React.StrictMode>
      <App />
    </React.StrictMode>
  </Provider>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
